/**
 * Component to render diferent tabs in a selector similar to a switch.
 */
export default {
  name: 'TabSelector',

  /**
   * @property {String} selectedTab String corresponding to the tab currently
   * selected to be emitted to the parent component.
   */
  data () {
    return {
      selectedTab: this.selectedOption
    }
  },

  /**
   * @property {Array} options Array passed to the component with the different
   * options available to be selected in the 'switch'.
   * @property {String} selectedOption currently selected option when the
   * component is instantiated.
   */
  props: {
    options: {
      type: Array,
      required: true
    },

    selectedOption: {
      type: String,
      required: true
    }
  },

  methods: {
    /**
     * The method handles when a tab option is clicked. If there is a tab change,
     * it modifies selectedTab and emits an event with the option selected.
     */
    handleClick (optionName) {
      if (!optionName) return
      this.selectedTab = optionName
      /**
       * @event click Emit when clicking on a tab with the name of the option
       * clicked.
       */
      this.$emit('click', optionName)
    }
  }
}
